import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { BUSINESS } from "../constants/business";
import { LogoMark } from "./LogoMark";

const LINKS = [
  ["Home", "home"],
  ["Services", "services"],
  ["Diesel Repair", "diesel"],
  ["Diagnostics", "diagnostics"],
  ["About Us", "about"],
  ["Reviews", "reviews"],
  ["FAQ", "faq"],
  ["Contact", "contact"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 150 : 0);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/90 backdrop-blur-md border-b border-zinc-800" data-testid="main-nav">
      <div className="px-6 md:px-12 lg:px-24 h-[72px] flex items-center justify-between">
        <button onClick={() => go("home")} className="flex items-center focus-visible:ring-2 focus-visible:ring-[#FF3B30] focus-visible:outline-none" data-testid="nav-logo" aria-label="Ascencio Auto Repair — home">
          <LogoMark className="h-10 w-auto" testId="nav-logo-img" />
        </button>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              onClick={() => go(id)}
              data-testid={`nav-link-${id}`}
              className="text-xs uppercase tracking-[0.15em] text-zinc-400 hover:text-[#FF3B30] transition-colors duration-200 font-medium focus-visible:ring-2 focus-visible:ring-[#FF3B30] focus-visible:outline-none"
            >
              {label}
            </button>
          ))}
          <button
            onClick={() => go("request")}
            data-testid="nav-request-service-btn"
            className="bg-[#FF3B30] text-white text-xs uppercase tracking-[0.15em] font-semibold px-5 py-3 hover:bg-white hover:text-black transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
          >
            Request Service
          </button>
        </nav>

        <button
          className="lg:hidden text-white p-2 focus-visible:ring-2 focus-visible:ring-[#FF3B30] focus-visible:outline-none"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden bg-[#0A0A0A] border-t border-zinc-800 px-6 py-6 flex flex-col gap-1" aria-label="Mobile" data-testid="nav-mobile-menu">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              onClick={() => go(id)}
              data-testid={`nav-mobile-link-${id}`}
              className="text-left font-oswald uppercase text-2xl tracking-tight text-zinc-300 hover:text-[#FF3B30] py-2 transition-colors duration-200"
            >
              {label}
            </button>
          ))}
          <button
            onClick={() => go("request")}
            data-testid="nav-mobile-request-btn"
            className="mt-4 bg-[#FF3B30] text-white font-oswald uppercase tracking-wide text-lg px-6 py-4 hover:bg-white hover:text-black transition-colors duration-200"
          >
            Request Service
          </button>
          <p className="mt-6 text-xs text-zinc-500">{BUSINESS.hoursDays} · {BUSINESS.hoursTime}</p>
        </nav>
      )}
    </header>
  );
};
